// 申请调解
import httpServer from '@/api/http';

// 获取案件详情
export const getCaseDetails = (data) => {
  return httpServer (
    {
      url: '/case/getCaseDetails',
    },
    data,
  );
};

// 获取案件详情
export const addCase = (data) => {
  return httpServer (
    {
      url: '/case/addCase',
    },
    data,
  );
};